import BrowserStorage from './BrowserStorage';
import MemoryStorage from './MemoryStorage';
import { IStorage } from './interfaces';

export default class WebStorage {
    private storage: IStorage;

    constructor() {
        const test = 'betgames:webStorage-test-key';

        try {
            localStorage.setItem(test, '1');
            localStorage.removeItem(test);
            this.storage = new BrowserStorage();
        } catch (e) {
            this.storage = new MemoryStorage();
            console.warn('Browser webStorage not available. Memory webStorage will be used');
        }
    }

    public getItem(key: string): string {
        return this.storage.getItem(key);
    }

    public getItemParsed<T>(key: string): T {
        let value: T;

        try {
            value = JSON.parse(this.storage.getItem(key)) as T;
        } catch (e) {
            value = undefined;
        }

        return value;
    }

    public setItem(key: string, value: string): void {
        this.storage.setItem(key, value);
    }

    public setItemParsed(key: string, value: unknown): void {
        try {
            this.storage.setItem(key, JSON.stringify(value));
        } catch (e) {
            this.storage.setItem(key, undefined);
        }
    }

    public removeItem(key: string): void {
        this.storage.removeItem(key);
    }

    public clear(): void {
        this.storage.clear();
    }
}
